const baseURL = "https://erp.cranoistmhe.com/"
// const baseURL = "http://127.0.0.1:8000/"
// const baseURL = "http://168.231.123.187/"
const config = {
    
    apiBaseURL : `${baseURL}`,
    staticBaseURL : `${baseURL}`,
    apiTimeout: 500000
}
export default config;

